import { Area } from "./area";

export const EXCEPTION_TYPES: Record<string, string> = {
    france: "Tarif negocié France",
    world: "Prix spéciaux monde"
};

export interface UsageRate {
    uuid: string;
    name: string;
    description: string;
    is_landline: boolean;
    is_exception: boolean;
    is_default: boolean;
    service: string;
    type?: string;
}

export interface UsageRatePatch {
    name: string;
    description: string;
    type?: string;
}

export interface UsageRateArea {
    area: Area;
    price: number;
}

export interface UsageRateAreaCreate {
    area: string;
    price: number
}

export interface UsageRateAreaPatch {
    price: number
}

export interface UsageRateZone {
    zone: string;
    price: number;
}

export interface UsageRateZonePatch {
    price: number;
}

export interface UsageRateExtended {
    uuid: string;
    name: string;
    description: string;
    is_landline: boolean;
    is_exception: boolean;
    is_default: boolean;
    service: string;
    type?: string;
    areas: UsageRateArea[];
    zones: UsageRateZone[];
}